<template>
  <Modal v-bind="$attrs" v-on="$listeners" @closed="closed">
    <div class="overflow-hidden rounded main-height">
      <div class="main-height overflow-auto">
        <div class="flex justify-between">
          <div class="font-bold title mb-2">
            エージェント通知先マスタ
          </div>
        </div>

        <div class="text-red-700 mb-1 font-bold">
          1行ごとに入力を保存してください
        </div>

        <div class="font-bold flex justify-between mt-2">
          Chatwork

          <div class="py-1 px-2 cursor-pointer" @click="add(1)">
            <Icon
              iconName="PlusCircle"
              class="w-8 h-8 text-blue-800"
            />
          </div>
        </div>

        <table class="overflow-auto main table-auto mb-3">
          <thead class="main bg-white">
            <tr v-if="1 && list1.length" class="border border-gray-200">
              <th v-for="(c, index) in columns" :key="'c1'+index" scope="col" class="px-2 py-3 text-xs font-medium text-gray-500 tracking-wider bg-colu text-left whitespace-pre-line" :class="c.class">
                {{c.title}}
              </th>
            </tr>
          </thead>

          <tr v-for="(row, i) in list1" :key="'c'+i" class="border border-gray-200 tracking-wider hover-color">

            <!-- エージェント名 -->
            <td class="px-2 py-0.5 text-gray-600">
              <input
                type="text"
                class="border border-gray-300 rounded-md focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 py-1.5 text-xs w-52"
                v-model="row.userName"
                @input="edit(row)"
              />
            </td>

            <!-- ルームID -->
            <td class="px-2 py-0.5 text-gray-600">
              <input
                type="number"
                class="border border-gray-300 rounded-md focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 w-32 py-1.5 text-sm"
                v-model="row.roomId"
                @input="edit(row)"
              />
            </td>

            <!-- トークン -->
            <td class="px-2 py-0.5 text-gray-600">
              <input
                type="text"
                class="border border-gray-300 rounded-md focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 text-xs w-60 py-2.5"
                v-model="row.apiToken"
                @input="edit(row)"
              />
            </td>

            <td class="px-1 py-0.5 text-center text-sm font-medium border-gray">
              <div class="flex justify-center">
                <PrimaryButton text="保存" size="normal" class="w-16 p-1" :disabled="!row.editFlg" :class="!row.editFlg?'bg-gray-300':'bg-blue-800'" @click="save('chatwork', row)" />
                <PrimaryButton text="削除" size="normal" class="ml-2 w-16 p-1 bg-red-700" @click="remove(row, i, 1)" />
              </div>
            </td>
          </tr>
        </table>

        <div class="font-bold flex justify-between mt-6">
          Mail

          <div class="py-1 px-2 cursor-pointer" @click="add(2)">
            <Icon
              iconName="PlusCircle"
              class="w-8 h-8 text-blue-800"
            />
          </div>
        </div>

        <div class="text-gray-600 mt-2 mb-1 font-bold text-sm">
          ※メールで通知しているエージェントにはChatwork通知に変更していただくよう促してください。（グループ内で情報共有できるため）
        </div>
        <div class="text-red-600 mb-1 font-bold text-sm">
          ※【エージェント名・ご担当者】はそのままメールに記載します。ご担当者名が不明な場合は「ご担当者様」とご記入ください。）
        </div>

        <table class="overflow-auto main table-auto mb-3">
          <thead class="main bg-white">
            <tr v-if="list2 && list2.length" class="border border-gray-200">
              <th v-for="(c, index) in columns2" :key="'c2'+index" scope="col" class="px-2 py-3 text-xs font-medium text-gray-500 tracking-wider bg-colu text-left whitespace-pre-line" :class="c.class">
                {{c.title}}
              </th>
            </tr>
          </thead>

          <tr v-for="(row, i) in list2" :key="'m'+i" class="border border-gray-200 tracking-wider hover-color">

            <!-- エージェント名 -->
            <td class="px-2 py-0.5 text-gray-600" v-tooltip="'そのままメールに記載します。ご担当者名が不明な場合は「ご担当者様」とご記入ください。'">
              <textarea
                class="border border-gray-300 rounded-md focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 py-1.5 text-xs w-52"
                v-model="row.userName"
                @input="edit(row)"
              />
            </td>

            <!-- ルームID -->
            <td class="px-2 py-0.5 text-gray-600">
              <input
                type="email"
                class="border border-gray-300 rounded-md focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 w-full py-1.5 text-sm"
                v-model="row.other"
                @input="edit(row)"
              />
            </td>

            <td class="px-1 py-0.5 text-center text-sm font-medium border-gray">
              <div class="flex justify-center">
                <PrimaryButton text="保存" size="normal" class="w-16 p-1" :disabled="!row.editFlg" :class="!row.editFlg?'bg-gray-300':'bg-blue-800'" @click="save('mail', row)" />
                <PrimaryButton text="削除" size="normal" class="ml-2 w-16 p-1 bg-red-700" @click="remove(row, i, 2)" />
              </div>
            </td>
          </tr>
        </table>

      </div>
      <div class="text-transparent">{{reload}}</div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import Icon from '@components/Icon.vue'
import * as utils from '@libs/utils'
import * as dialogs from '@libs/dialogs'
import * as logManager from '@managers/logManager'
import * as backend from '@libs/backend'
import { CHAT_TOKEN } from '@/config'

const COL = [
        {title: 'エージェント名'},
        {title: 'ルームID'},
        {title: 'APIトークン'},
        {title: ''},
      ]

const COL2 = [
        {title: 'エージェント名・ご担当者'},
        {title: 'メールアドレス'},
        {title: ''},
      ]

// 行
const ROW = { editFlg: false, userName: '', roomId: null, apiToken: null, other: null }

export default {
  components: {
    Modal,
    PrimaryButton,
    Icon
  },

  props: ['open'],

  data() {
    return {
      // ローディング
      loading: false,
      // カラム
      columns: utils.clone(COL),
      columns2: utils.clone(COL2),
      // リスト
      list1: [],
      list2: [],
      reload: 0
    }
  },

  watch: {
    open() {
      if (this.open) {
        this.getData()
      }
    }
  },

  methods: {
    /**
     * 初期にリセット
     */
    closed() {
      // リスト
      this.list1 = []
      this.list2 = []
      this.loading = false
      this.$emit('getAgentList')
      this.$emit('close')
    },

    /**
     * リスト取得
     */
    async getData() {
      this.loading = true
      const res = await backend.searchData('chatworkData/getByType', { type: 3 })
      if (res.data.data) {
        this.list1 = res.data.data.filter((row) => {
          return !row.other
        })
        this.list2 = res.data.data.filter((row) => {
          return row.other
        })
      }
      if (!this.list1.length) {
        this.add(1)
      }
      if (!this.list2.length) {
        this.add(2)
      }
      this.loading = false
    },

    /**
     * 編集ボタンイベント
     * @param item 対象項目名
     * @param row 編集対象データ
     */
    edit(row) {
      row.editFlg = true
      this.reload++
    },

    /**
     * 保存
     * @param category chatwork、mail
     * @param row 対象データ
     */
    async save(category, row) {
      row.category = category

      if (!row.userName) {
        await dialogs.showErrorDialog('エージェント名', 'エージェント名を入力してください。')
        return
      }
      if (category === 'chatwork') {
        if (!row.roomId) {
          await dialogs.showErrorDialog('ルームID', '未入力です。ルームIDを入力してください。')
          return
        }
        if (!row.roomId) {
          await dialogs.showErrorDialog('APIトークン', '未入力です。APIトークンを入力してください。')
          return
        }

        // 同じルームIDがないかチェック
        const room = this.list1.filter((r) => {
          return r.roomId == row.roomId
        })
        if (room && room.length > 1) {
          const dia = await dialogs.showConfirmDialog('ルームID重複あり', 'すでに同じルームIDが登録されていますが、よろしいでしょうか？')
          if (dia != 'YES') {
            return
          }
        }
        row.other = null
      } else {
        if (!row.userName.includes('様')) {
          await dialogs.showErrorDialog('ご担当者名', 'エージェント名・ご担当者名はそのままメールに記載します。\r\nご担当者名が不明な場合は「ご担当者様」とご記入ください。\r\n「様」の敬称がないと保存できません。')
          return
        }
        if (!row.other) {
          await dialogs.showErrorDialog('メールアドレス', '未入力です。メールアドレスを入力してください。')
          return
        }

        // 同じメアドがないかチェック
        const mail = this.list2.filter((r) => {
          return r.other == row.other
        })
        if (mail && mail.length > 1) {
          const dia = await dialogs.showConfirmDialog('メールアドレス重複あり', 'すでに同じメールアドレスが登録されていますが、よろしいでしょうか？')
          if (dia != 'YES') {
            return
          }
        }
        row.roomId = 0
        row.apiToken = ''
      }

      const saveData = utils.clone(row)
      delete saveData.editFlg

      // ログ登録内容
      let newFlag = true
      if (row._id || row.id) {
        newFlag = false
      }

      let msg = ''
      saveData.type = 3
      saveData.insertUser = this.$store.getters.user.id
      await backend.postData('chatworkData/saveChat', saveData)
      msg = `新卒採用エージェント：${row.userName}`

      logManager.recordingByRegist(this, newFlag, '新卒採用エージェント', msg)
      await dialogs.showSuccessDialog('保存しました')
      row.editFlg = false
      this.getData()
    },

    /**
     * 削除
     * @param row 対象データ
     * @param i インデックス
     * @param num 1：chatwork、2：mail
     */
    async remove(row, i, num) {
      // 既に保存済み
      if (row._id || row.id) {
        // ログ登録内容
        let msg = ''
        const res = await dialogs.showConfirmDialog('削除してよろしいですか？', `${row.userName}さんを削除します。`)
        if (res != 'YES') {
          return
        }
        await backend.deleteData('chatworkData/deleteChat', row, false)
        msg = `${row.userName}を削除しました。`
        logManager.recording(this, logManager.Loglevel.INFO, this.typeName, '削除', msg)
        await dialogs.showSuccessDialog('削除しました')
      }
      this['list' + num].splice(i, 1)
    },

    /**
     * 追加ボタン
     */
    add(num) {
      let row = utils.clone(ROW)
      row.apiToken = CHAT_TOKEN

      this['list' + num].push(row)
    },
  }
}
</script>
<style scoped>
.main-height {
  height: 85vh;
}

.main {
  width: 100%;
  min-width: 700px;
}

.bg-colu {
  background: #edecf7;
}

.hover-color:hover {
  background: #edecf7 !important;
}

.title {
  color: #7b77b9;
}

textarea {
  field-sizing: content !important;
}
</style>